import client from "../../../apolloClient";
import { gql } from "apollo-boost";

export const getScratchStarterCode = (id) => {
  return client.query({
    query: gql`
      query GetScratchStarterCode {
        ScratchStarterCodeQuery(id: "${id}") {
          id
          base64Str
        }
      }
    `
  });
};
